import { render, staticRenderFns } from "./AppHeaderSpMenu.vue?vue&type=template&id=c321810a&scoped=true"
import script from "./AppHeaderSpMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppHeaderSpMenu.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppHeaderSpMenu.vue?vue&type=style&index=0&id=c321810a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c321810a",
  null
  
)

export default component.exports